import { render, staticRenderFns } from "./lc-success-alert.vue?vue&type=template&id=e12fc7a8&scoped=true&"
import script from "./lc-success-alert.vue?vue&type=script&lang=js&"
export * from "./lc-success-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12fc7a8",
  null
  
)

export default component.exports